import { render, staticRenderFns } from "./FinanzasIcon.vue?vue&type=template&id=6c0d92f1"
import script from "./FinanzasIcon.vue?vue&type=script&lang=js"
export * from "./FinanzasIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports